import { login, userinfo, resetPassword, selectConfig } from "@/api/user";
import store from "@/store/index";
import router from "@/router";

import jsencrypt from "@/utils/encryption";
// 获取用户信息
import { Message } from "element-ui";
import { loginOut, getIsAndroid } from "@/api/androidApi";
export default {
  namespaced: true, // 开启命名空间
  state: {
    token: "",
    userInfo: "", // 用户信息
    id: "", // 用户登录网址id
    roles: [], // 身份信息
    routerList: [],
    selectlist: "", //查询列表数据
    Device: "", // 设备信息
  },
  mutations: {
    // 修改token
    setToken(state, TokenVal) {
      state.token = TokenVal;
      state.routerList = [
        {
          id: 1,
          title: "系统设置",
          icon: "el-icon-s-tools",
          children: [
            {
              label: "组织部门",
              key: "/department",
            },
            {
              label: "员工权限",
              key: "/staff",
            },
            {
              label: "规范管理",
              key: "/standardManagement",
            },
            {
              label: "设备管理",
              key: "/deviceManagement",
            },
          ],
        },
        {
          id: 2,
          title: "软件信息",
          icon: "el-icon-menu",
          children: [
            {
              label: "软件更新",
            },
            {
              label: "用户手册",
            },
            {
              label: "联系我们",
            },
          ],
        },
      ];
    },
    // 修改info
    setInfo(state, infoVal) {
      state.userInfo = infoVal;
    },
    //修改查询列表
    setInfolist(state, listVal) {
      state.selectlist = listVal;
    },
    // 退出登录
    logout(state, fullPath) {
      state.token = "";
      state.userInfo = "";
      state.id = "";
      state.roles = [];
      state.routerList = [];
      store.dispatch("tagsView/delAllViews");
      store.commit("permission/CLEAR_ROUTES");
      if (getIsAndroid()) {
        loginOut();
      } else {
        router.push(fullPath ? fullPath : "/login");
      }
    },

    // --- 获取路径
    getData(state) {
      const path1 = location.href.split("?")[1];
      if (path1) {
        state.id = path1.split("#")[0];
      }
    },
    // 设置身份
    SET_ROLES(state, val) {
      state.roles = val;
    },
    // 设置设备信息
    SET_DEVICE(state, val) {
      state.Device = val;
    },
  },
  actions: {
    // 获取用户使用设备
    async getDevice(store) {
      try {
        var deviceInfo = deviceUUID.getDeviceUUID();
        store.commit("SET_DEVICE", deviceInfo);
      } catch (error) {}
    },

    // 登录接口
    async toLogin(store, form) {
      const res = await login({
        username: form.username,
        password: jsencrypt.encrypt(form.password),
        imei: store.state.Device,
      }); // 传入登录的form表单信息
      if (res.code === 200) {
        const info = res.data;
        store.commit("setToken", info.token); // 调用成功,给token赋值并保存
        store.dispatch("getUerInfo", info.token);
        store.dispatch("selectconfig");

        switch (res.data.type) {
          case 1:
            store.commit("SET_ROLES", ["admin"]);
            break;
          case 2:
            store.commit("SET_ROLES", ["editor"]);
            break;
          default:
            store.commit("SET_ROLES", ["people", "admin"]);
            break;
        }
      } else {
        Message.error("账户或密码错误"); // 正确 success, 错误 error
      }
    },
    async getUerInfo(store, token) {
      const infores = await userinfo(token); // 获取用户表单信息
      store.commit("setInfo", infores.data);
      // 安卓端-保存用户信息
      if (!!store.state.Device) {
        WebAppInterface.setUserInfo(JSON.stringify(infores.data));
      }
    },
    async selectconfig(store, obj) {
      const infolist = await selectConfig(obj ? obj : ""); // 获取查询列表数据
      store.commit("setInfolist", infolist.data);
    },
    async resetPassword(store, form) {
      try {
        await resetPassword({
          origin_password: jsencrypt.encrypt(form.origin_password), //	是	string	原密码
          new_password: jsencrypt.encrypt(form.new_password), //	是	string	新密码
          confirm_password: jsencrypt.encrypt(form.confirm_password), //	否	string	确认密码
        }); // 修改密码
        store.commit("logout");

        Message.error("用户信息已过期,请重新登录");
      } catch (error) {}
    },
  },
  getters: {},
};
